import * as React            from "react";
import {cs}                  from "@Common/react/chain-services";

export const daniel_gale_sothebys_gen_buscard = ({idBranch, session, specificationFields, specFieldOnChange, next}) => cs(

    ["disabledFields", ({}, next) => next([
        "field_69",
        "field_70",
    ])],

    // precedingTextBlocks are blocks of text that are displayed before certain fields if those fields are present.
    ["precedingTextBlocks", ({}, next) => next({
        "field_66":
            "All CAPS are not allowed. ",

        "field_71":
            "To modify the office address, please have the Office Manager or Administrator contact Xpressdocs at 866-977-3627 Ext 0",

        "field_73":
            "An alpha prefix must accompany each phone number listed. Please select the appropriate letter from the drop-down menu.",

        "field_78":
            "Use your Sotheby\'s International Realty company website address, without the \'www\' prefix.",
    })],

    // The next 4 variables arrays containing 4 different types of fields that are used together to create a multipart phone field
    // prefixFields are dropdowns that determine the prefix of the multipart phone fields
    ["prefixFields", ({}, next) => next([
        "field_16",
        "field_17",
        "field_18",
        "field_19",
    ])],
    // phoneInputFields determine the label of the multipart phone fields, as well as being the input for the actual phone number
    ["phoneInputFields", ({}, next) => next([
        "field_73",
        "field_74",
        "field_75",
        "field_76",
    ])],
    // extPrefixFields are dropdowns that allow an "x" or "none" to be selected, to prefix the extension
    ["extPrefixFields", ({}, next) => next([
        "field_79",
        "field_81",
        "field_83",
        "field_85",
    ])],
    // extensionFields are the input for the actual extension number
    ["extensionFields", ({}, next) => next([
        "field_80",
        "field_82",
        "field_84",
        "field_86",
    ])],

    ["multipartFieldStructures", ({}, next) => next({
        "field_73": {
            prefixField: "field_16",
            extensionPrefixField: "field_79",
            extensionField: "field_80",
        },
        "field_74": {
            prefixField: "field_17",
            extensionPrefixField: "field_81",
            extensionField: "field_82",
        },
        "field_75": {
            prefixField: "field_18",
            extensionPrefixField: "field_83",
            extensionField: "field_84",
        },
        "field_76": {
            prefixField: "field_19",
            extensionPrefixField: "field_85",
            extensionField: "field_86",
        },
    })],

    ["prefixOptions", ({}, next) => next({
        "field_73": ["o"],
        "field_74": ["c", "f", "h", "d"],
        "field_75": ["c", "f", "h", "d"],
        "field_76": ["c", "f", "h", "d"],
        "default": ["t", "f", "c", "h", "d", "o", "n", "m", "vm"],
    })],

    ["personalDesignationOptions", ({}, next) =>
        next({
          "personal designation": {
            ", ABR": "ABR",
            ", CBR": "CBR",
            ", CCIM": "CCIM",
            ", CLHMS": "CLHMS",
            ", CRB": "CRB",
            ", CRP": "CRP",
            ", CRS": "CRS",
            ", GRI": "GRI",
            ", RS": "RS",
            ", SRES": "SRES",
            ", WCR": "WCR",
            ", RSSC": "RSSC",
          },
          "title 1": [
            "Associate Real Estate Broker",
            "Real Estate Salesperson",
            "Sales Manager",
            "Assistant Sales Manager",
          ],
          "title 2": [
            "Gold Circle of Excellence",
            "Silver Circle of Achievement",
            "Sterling Circle of Accomplishment",
          ],
        })
    ],
    ["readOnlyFields", ({}, next) => next([
        "field_71",
        "field_72",
    ])],
    ["specFieldDuplicates", ({}, next) => next([])],
    (({specFieldDuplicates}, next) => next(specFieldDuplicates.push({
        ordinal: 1,
        idPrimary: null,
        fieldKey: null,
        displayLabel: "",
        data: "To comply with Sotheby's International Realty brand standards, and to avoid reprinting charges, please ensure you follow field instructions. In general, we do not permit the use of all CAPS, so use proper upper and lower case characters in all fields. Thank you for upholding the high standards of our brand.",
        idDisplayStyle: 20,
        visible: true,
        ignoreSave: true,
    }))),
    ["ordinalPosition", ({}, next) => next(2)],
    (({disabledFields, precedingTextBlocks, prefixFields, phoneInputFields, extPrefixFields, extensionFields, multipartFieldStructures, prefixOptions, specFieldDuplicates, ordinalPosition,personalDesignationOptions, readOnlyFields}, next) => next(
        specificationFields.map( field => {

            const disabledByLabel = ['address:', 'address2:', 'city, st zip'];

            if( disabledFields.includes(field.fieldKey) || disabledByLabel.includes(field.displayLabel.toLowerCase()) ) {
                field.isEditable = false;
                field.idDisplayStyle = 7;
            }
            if(readOnlyFields.includes(field.fieldKey)) {
                field.isEditable = false;
            }

            if (!!precedingTextBlocks[field.fieldKey]) {
                // create field with {...ordinal: ordinalPosition} & increment the ordinal position of the current field
                const newTextBlockField = {...field,
                    ordinal: ordinalPosition,
                    idPrimary: null,
                    fieldKey: field.fieldKey + "-textBlock",
                    data: precedingTextBlocks[field.fieldKey],
                    idDisplayStyle: 20,
                    visible: true,
                    ignoreSave: true,
                };
                specFieldDuplicates.push(newTextBlockField);
                ordinalPosition++;
            }
            const matchedKey = Object.keys(personalDesignationOptions).find((key) =>
                field.displayLabel.toLowerCase().includes(key.toLowerCase())
              );

            if (matchedKey) {
            field.defaultValue = JSON.stringify(personalDesignationOptions[matchedKey]); // Assign options dynamically
            field.idDisplayStyle = 3; // Set as dropdown
            }

            if  ([prefixFields, phoneInputFields, extPrefixFields, extensionFields].flat().includes(field.fieldKey)) {
                // create new multipart phone fields to for display & to take input to ass to original fields
                if (phoneInputFields.includes(field.fieldKey)) {
                    const newMultipartField = {
                        ...field,
                        ordinal: ordinalPosition,
                        idPrimary: null,
                        fieldKey: field.fieldKey + "-multipartPhone",
                        data: null,
                        idDisplayStyle: 21,
                        visible: true,
                        prefixOptions: prefixOptions[field.fieldKey] ?? prefixOptions['default'],
                        prefixField: multipartFieldStructures[field.fieldKey].prefixField,
                        extensionPrefixField: multipartFieldStructures[field.fieldKey].extensionPrefixField,
                        extensionField: multipartFieldStructures[field.fieldKey].extensionField,
                        ignoreSave: true,
                    };
                    specFieldDuplicates.push(newMultipartField);
                    ordinalPosition++;
                }
                // This will make the original fields hidden, so we can update their value & extract data from them on save, but display them differently.
                field.idDisplayStyle = 6;
                field.visible = false;
                if  ([prefixFields].flat().includes(field.fieldKey)) {
                    field.defaultValue = null;
                    field.data = null;
                }
            }
            // These will behave like deletable text fields, but display like regular fields with deletion triggered by an empty field value
            else if ( !disabledFields.includes(field.fieldKey) && !disabledByLabel.includes(field.displayLabel.toLowerCase()) && !matchedKey && field.idDisplayStyle == 2 ) {
                field.idDisplayStyle = 1;
            }

            // If no current value in field (default data, reorder, pending order), map default data specific to buildPath to fields by displayLabel
            if (!field.data) {
                switch( field.displayLabel.toLowerCase() ) {
                    case 'agent name:':
                        field.data = session.data.agent?.agentNameFirst
                        +' '
                        + (session.data.agent?.agentNameMiddle?.length ? session.data.agent?.agentNameMiddle + ' ' : '')
                        + session.data.agent?.agentNameLast;
                        break;

                    case 'first name':
                        field.data = session.data.agent?.agentNameFirst;
                        break;

                    case 'last name':
                        field.data = session.data.agent?.agentNameLast;
                        break;

                    case 'address:':
                        field.data = session.data.branch?.branchAddress1 + " " + session.data.branch?.branchAddress2;
                        break;

                    case 'address2:':
                        field.data = session.data.branch?.branchCity + ", " + session.data.branch?.branchState + " " +  session.data.branch?.branchZip;
                        if( field.data.length < 6 ) field.data = '';
                        break;

                    case 'city, st zip':
                        field.data = session.data.branch?.branchCity + ", " + session.data.branch?.branchState + " " +  session.data.branch?.branchZip;
                        if( field.data.length < 6 ) field.data = '';
                        break;

                    case 'email:':
                        field.data = session.data.agent?.agentEmail;
                        break;

                    case 'company name:':
                        field.data = "Daniel Gale";
                        break;

                    case 'company name 2:':
                        field.data = "Sotheby's International Realty";
                        break;

                    default:
                        field.data = field.data;
                }
            }
            // update field with new ordinal position, add to the specFieldDuplicates array, & incriment ordinalPosition
            field.ordinal = ordinalPosition;
            specFieldDuplicates.push(field);

            ordinalPosition++;
        }
    ))),

    (({specFieldDuplicates}, next) => next(specFieldOnChange(specFieldDuplicates))),
    ({specFieldDuplicates}) => next(specFieldDuplicates)
);